import { AUCTION_STATUSES, AuctionStatus } from '../../models/constants';
import { Box } from '../box';
import { Text } from '../text';

export function AuctionStatusBanner(props: {
  auctionStatus: AuctionStatus;
  locale: 'it' | 'en';
  contractType: string;
  rightSide?: boolean;
}) {
  const colorBg = auctionStatusColor(props.auctionStatus, props.contractType);
  return (
    <Box
      display={colorBg ? 'block' : 'none'}
      backgroundColor={colorBg}
      py={2}
      pl={5}
      pr={3}
      width={'fit-content'}
      borderTopRightRadius={props.rightSide ? '0px' : '4px'}
      borderBottomRightRadius={props.rightSide ? '0px' : '4px'}
      borderTopLeftRadius={props.rightSide ? '4px' : '0px'}
      borderBottomLeftRadius={props.rightSide ? '4px' : '0px'}
    >
      <Text
        color="white"
        width={'fit-content'}
        fontSize={1}
        style={{ whiteSpace: 'nowrap' }}
      >
        {(STRINGS[props.locale][props.auctionStatus] || '').toUpperCase()}
      </Text>
    </Box>
  );
}

const auctionStatusColor = (
  auctionStatus: AuctionStatus,
  contractType: string
): string | null => {
  if (contractType.toLowerCase() === 'affitto') return null;
  switch (auctionStatus) {
    case AUCTION_STATUSES.CREATED:
      return `rgba(217, 39, 146, 0.5)`;
    case AUCTION_STATUSES.RUNNING:
      return `#9E99C3`;
    case AUCTION_STATUSES.CLOSED_WITH_NO_BIDS:
    case AUCTION_STATUSES.CLOSED_WITH_WINNER_AND_RESERVED_PRICE_MET:
    case AUCTION_STATUSES.CLOSED_WITH_WINNER_AND_RESERVED_PRICE_NOT_MET:
    case AUCTION_STATUSES.SOLD:
    case AUCTION_STATUSES.SOLD_FOR_BUY_NOW:
    case AUCTION_STATUSES.NOT_SOLD:
    case AUCTION_STATUSES.BUY_NOW_ONLY_UNDER_EVALUATION:
    case AUCTION_STATUSES.UNDER_EVALUATION:
    case AUCTION_STATUSES.COMING_SOON:
      return `#c61811`;
    case AUCTION_STATUSES.ONLY_BUY_NOW:
    case AUCTION_STATUSES.BUY_NOW_UNDER_EVALUATION:
    default:
      return null; // status without class
  }
};

const STRINGS = {
  it: {
    [AUCTION_STATUSES.COMING_SOON]: 'In arrivo',
    [AUCTION_STATUSES.CREATED]: 'Asta in partenza',
    [AUCTION_STATUSES.UNDER_EVALUATION]: 'Offerta in corso',
    [AUCTION_STATUSES.BUY_NOW_UNDER_EVALUATION]: 'Offerta in corso',
    [AUCTION_STATUSES.BUY_NOW_ONLY_UNDER_EVALUATION]: 'Offerta in corso',
    [AUCTION_STATUSES.RUNNING]: 'Asta in corso',
    [AUCTION_STATUSES.CLOSED_WITH_NO_BIDS]: 'Asta chiusa',
    [AUCTION_STATUSES.CLOSED_WITH_WINNER_AND_RESERVED_PRICE_MET]: 'Asta chiusa',
    [AUCTION_STATUSES.CLOSED_WITH_WINNER_AND_RESERVED_PRICE_NOT_MET]:
      'Asta chiusa',
    [AUCTION_STATUSES.SOLD]: 'Venduto',
    [AUCTION_STATUSES.SOLD_FOR_BUY_NOW]: 'Venduto',
    [AUCTION_STATUSES.NOT_SOLD]: 'Non venduto',
  } as { [key in AuctionStatus]: string },
  en: {
    [AUCTION_STATUSES.COMING_SOON]: 'Coming soon',
    [AUCTION_STATUSES.CREATED]: 'Upcoming auction',
    [AUCTION_STATUSES.UNDER_EVALUATION]: 'Offer in progress',
    [AUCTION_STATUSES.BUY_NOW_UNDER_EVALUATION]: 'Offer in progress',
    [AUCTION_STATUSES.BUY_NOW_ONLY_UNDER_EVALUATION]: 'Offer in progress',
    [AUCTION_STATUSES.RUNNING]: 'Active auction',
    [AUCTION_STATUSES.CLOSED_WITH_NO_BIDS]: 'Auction closed',
    [AUCTION_STATUSES.CLOSED_WITH_WINNER_AND_RESERVED_PRICE_MET]:
      'Auction closed',
    [AUCTION_STATUSES.CLOSED_WITH_WINNER_AND_RESERVED_PRICE_NOT_MET]:
      'Auction closed',
    [AUCTION_STATUSES.SOLD]: 'Sold',
    [AUCTION_STATUSES.SOLD_FOR_BUY_NOW]: 'Sold',
    [AUCTION_STATUSES.NOT_SOLD]: 'Not sold',
  } as { [key in AuctionStatus]: string },
};
